import { MapPinIcon } from '@heroicons/react/24/outline';
import React from 'react';

function Location({label, small} : {label : string|undefined, small?: boolean}) {

    if (small) {
        return <div className="text-center"><MapPinIcon className="inline h-6 w-6" /> <span className="pt-2">{label}</span></div>;
    }

    return <div>
        <div><MapPinIcon className="inline h-10 w-10" /></div>
        <div className="mt-3">{label}</div>
    </div>;

}

export default Location;